/* eslint-disable max-len */
import React, { useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Select,
} from 'antd';
import {
  Input,
} from 'components/gyramais';

import {
  useQuery,
} from '@apollo/client';

import { selectSearcher } from 'utils/select';
import { formatString } from 'utils';
import BUSINESS from '../../graphql/business.gql';
// import BUSINESS_PLATFORM_TYPES from '../../graphql/businessPlatformTypes.gql';
// import BUSINESS_SEGMENTS from '../../graphql/businessSegments.gql';
// import BUSINESS_SECTORS from '../../graphql/businessSectors.gql';
import pendingInputs from '../../inputs-data/pending-inputs';

const { Item } = Form;
const { Option } = Select;

const BusinessInfoBack = ({
  businessId,
  form,
}) => {
  const {
    data: {
      business,
    } = {},
  } = useQuery(BUSINESS, {
    variables: {
      id: businessId,
    },
    skip: !businessId,
    onCompleted: ({ business }) => {
      form.setFieldsValue({
        ...business,
        platformType: business.platformType.value,
        sector: business.sector.value,
        segment: business.segment.value,
        employeesNumber: business.employeesNumber,
        revenueAmount: business.revenueAmount,
      });
    },
  });

  // const {
  //   data: {
  //     businessPlatformTypes,
  //   } = {},
  // } = useQuery(BUSINESS_PLATFORM_TYPES, {
  //   fetchPolicy: 'cache-and-network',
  // });

  // const {
  //   data: {
  //     businessSegments,
  //   } = {},
  // } = useQuery(BUSINESS_SEGMENTS, {
  //   fetchPolicy: 'cache-and-network',
  // });

  // const {
  //   data: {
  //     businessSectors,
  //   } = {},
  // } = useQuery(BUSINESS_SECTORS, {
  //   fetchPolicy: 'cache-and-network',
  // });

  useEffect(() => {
    if (!business?.id) {
      return;
    }
    const formObj = { id: business.id };

    const inputKeys = pendingInputs.map((input) => input.value);

    inputKeys.push('hasOtherBusinessParticipation');

    for (const inputKey of inputKeys) {
      let value = business[inputKey] ?? business.additionalInfo?.[inputKey];

      if (inputKey === 'cnpj') {
        value = formatString(value, 'cnpj');
      }
      if (inputKey === 'phoneNumber') {
        value = formatString(value, 'phone');
      }

      formObj[inputKey] = value;
    }

    if (!formObj.legalNature) {
      formObj.legalNature = '213-5';
    }

    // setHasOtherBusinessParticipation(business?.additionalInfo?.hasOtherBusinessParticipation);
    formObj.hasOtherBusinessParticipation = !!business
      ?.additionalInfo
      ?.hasOtherBusinessParticipation;

    form.setFieldsValue(formObj);
  }, [business?.id]);

  if (!business) return (<></>);

  return (
    <Form
      layout="vertical"
      form={form}
    >
      <Row gutter={12}>
        {pendingInputs.map((input) => (
          <Col xs={24} sm={24} md={24} lg={input.size}>
            <Item
              name={input.value}
              label={input.name}
              rules={[
                {
                  required: true,
                  message: `Por favor preencha o campo ${input.name.toLowerCase()}.`,
                },
                () => ({
                  validator(_, value) {
                    if (input.rules?.min) {
                      if (value < input.rules.min.value) {
                        return Promise.reject(input.rules.min.error);
                      }
                    }

                    return Promise.resolve();
                  },
                }),
              ].filter(Boolean)}
            >
              {input.options ? (
                <Select
                  className="gyramais-input"
                  placeholder={input.name}
                  showSearch
                  filterOption={selectSearcher}
                >
                  {input.options.map((option) => {
                    const optionName = option.name ?? option;
                    const optionValue = option.value ?? option;

                    return (
                      <Option
                        value={optionValue}
                        label={optionName}
                      >
                        {optionName}
                      </Option>
                    );
                  })}
                </Select>
              ) : (
                <Input
                  type={input.maskType ? 'masked' : input.type}
                  disabled={input.disabled}
                  className="ant-input"
                  guide
                  mask={input.maskType}
                  placeholder={input.name}
                />
              )}
            </Item>
          </Col>
        ))}
      </Row>
    </Form>
  );
};

export default BusinessInfoBack;
